import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Observable, Subject } from 'rxjs';
import { severity } from '../enums/toaster';


@Injectable({
  providedIn: 'root'
})
export class ToasterService {

  private toast_subject = new Subject<any>();
  toast_state = this.toast_subject.asObservable();
  position: string = 'tr';
  life: number = 3000;
  sticky: boolean = false

  constructor(private messageService: MessageService) {}

  getToast(): Observable<any> {
    return this.toast_subject.asObservable();
  }

  clearToast() {
    this.messageService.clear();
  }

  showSuccess(message: string, sticky: boolean = this.sticky, summary: string = 'Success', life:number = this.life, position: string = this.position) {
    this.toast_subject.next({ severity: severity.success, detail: message, summary: summary, sticky: sticky, life: life, key: position });
  }

  showInfo(message: string, sticky: boolean = this.sticky, summary: string = 'Info', life:number = this.life, position: string = this.position) {
    this.toast_subject.next({ severity: severity.info, detail: message, summary: summary, sticky: sticky, life: life, key: position });
  }

  showWarn(message: string, sticky: boolean = this.sticky, summary: string = 'Warning', life:number = this.life, position: string = this.position) {
    this.toast_subject.next({ severity: severity.warn, detail: message, summary: summary, sticky: sticky, life: life, key: position });
  }

  showError(message: string, sticky: boolean = this.sticky,  summary: string = 'Error', life:number = 6000, position: string = this.position) {
    this.toast_subject.next({ severity: severity.error, detail: message, summary: summary, sticky: sticky, life: life, key: position });
  }

  showMultiple(message: string, sticky: boolean = this.sticky, life:number = this.life, position: string = this.position) {
    this.toast_subject.next(
      [
        { severity: severity.success, detail: message, summary: 'Success', sticky: sticky, life: life, key: position },
        { severity: severity.info, detail: message, summary: 'Info', sticky: sticky, life: life, key: position },
        { severity: severity.warn, detail: message, summary: 'Warning', sticky: sticky, life: life, key: position },
        { severity: severity.error, detail: message, summary: 'Error', sticky: sticky, life: life, key: position }
      ]
    );
  }
}
